import styled from 'styled-components/native';

import { brandSpecificNavBorderStyle } from './mobile-web-navigation-border.styled';

export const MobileWebNavigationBorder = styled.SafeAreaView`
  padding-top: 0px;
  background: ${Styles.color.white};
  shadow-color: ${Styles.shadowColor};
  shadow-offset: ${Styles.shadowOffset};
  shadow-radius: ${Styles.shadowRadius};
  width: 100%;
  z-index: ${Styles.zIndex.overlay};
  ${brandSpecificNavBorderStyle}
`;
